export default {
  components:{
    search:{
      placeholder: "Поиск",
      enterButton: "Найти",
    },
    adms:{
      repository_tooltip  : `Всего {{count}} записей. Ещё доступно {{length}} записей.`,
      repository_load_next: "Загрузить ещё",
      distribution: {
        title: "Распространение элемента каталога",
        nolinks: "Распространение элемента каталога не осуществляется.",
        nofiles: "Для содержимого нет файла для скачивания",
        show: {
          title: "Детальная информация о распространении",
          cancelText: "Отмена",
          okText: "Ок",
          },
        add: {
          title: "Выбор файла для связывания",
          cancelText: "Отменить",
          okText: "Связать",
          },
        unlink:{
          title: 'Удалить выбранный элемент',
          okText: 'Да', 
          cancelText: 'Нет',
        },
        message: {
          ok_link: "Файл добавлен.",
          ok_unlink: "Запись удалена.",
          e_detail: "Ошибка при получении дополнительной информации и распространении элемента каталога. {{detail}}",
          e_search: "Ошибка при поиске файлов. {{detail}}",
        }
      },
    },
    widgets: {
      description_moreText: "Далее",
      description_lessText: "Свернуть",
    },
    wiki: {
      title: "Wiki статьи",
      nolinks: "Нет связанных wiki статей",
      select: {
        title: "Выбор wiki-статьи",
        cancelText: "Отменить",
        okText: "Связть",
      },
      unlink_dialog:{
        title: 'Удалить выбранный элемент',
        okText: 'Да', 
        cancelText: 'Нет',
      },
      message: {
        ok_link: "Статья добавлена.",
        ok_unlink: "Запись удалена.",
        e_detail: "Ошибка при получении дополнительной информации и распространении элемента каталога. {{detail}}",
        e_search: "Ошибка при поиске статей. {{detail}}",
      }
    }
  },
  views:{
    adms:{
      list_add_title: "Добавление нового элемента в каталог",
      list_reload_title: "Пересчитать список",
      card_tab_card: "Карточка",
      card_tab_collaboration: "Коллективная работа",
      card_tab_content: "Содержимое",
      collaboration: {
        lifecycle_header: "Жизненный цикл",
        lifecycle_none: "Нет жизненного цикла, связанного с элементом каталога",
        event_header: "События",
        event_none: "Нет событий, связанных с элементом каталога",
        wiki_header: "Wiki",
      }
    }
  }
}
